import { AfterViewInit, Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-admin-setting',
  templateUrl: './admin-setting.component.html',
  styleUrls: ['./admin-setting.component.scss']
})
export class AdminSettingComponent implements OnInit, AfterViewInit {
  StudentEdit: FormGroup;
  ss: any[];
  payload: any;
  submitpayload: any[];
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, 
    public router: Router,
    ) {}
  a:any = [];
  arr1:any = [];
  aar: any = [];
  AdminArr: any = [];
  Arr= [
    {
      name: '', 
      display: '', 
      Require: true, 
      Visible: true, 
      pattern: '', 
      form: '', 
      type: '', 
      page: '', 
      default: false
    },
   
  ];

  ngOnInit(): void {
    let i = 0;
    let id = '';
    this.StudentEdit = this.fb.group({
      arrData: this.fb.array([]),
    });
    this.addNew(i);
    this.GetData(id);
  }

  ngAfterViewInit(): void{
  }
  getData(i)
  {
  let data = (<FormArray>this.StudentEdit.get("arrData")).at(i);
  }
  

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  next(){
    this.redirect('student-setting');
  }

  save(){
    this.spinner.show()
    let payload = this.StudentEdit.value;
    payload.arrData.forEach(element => {
      this.umsService.addStdSetting(element).subscribe(res => {
        this.spinner.hide()
        let data = res.data
      });
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    
    
    
  }

  addNew(i) {
    const creds = this.StudentEdit.controls.arrData as FormArray;
    creds.push(
      this.fb.group({
        FormName: new FormControl ('', [Validators.required]),
        FormRequired: new FormControl (''),
        FormVisible: new FormControl (''),
        FormDisplayName: new FormControl ('', [Validators.required]),
        FormPattern: new FormControl ('', [Validators.required]),
        FormControlName: new FormControl ('', [Validators.required]),
        FormType: new FormControl('', [Validators.required]),
        FormPage: new FormControl('', [Validators.required]),
        IsDefault: new FormControl('', [Validators.required]),
      })
    );
  }

  GetData(id){
    this.spinner.show();
    const payload = {};
    payload['FormRequired'] = id;
    payload['FormVisible'] = id;
    payload['FormPage'] = id;
    payload['IsDefault'] = true;
      this.umsService.getStdSetting(payload).subscribe(res => {
        this.spinner.hide()
        let data = res.data
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      });
   
  }

}
